import { useBarIndicatorsColors } from '@/composables/useBarIndicatorsColors';
import { BREAKPOINTS } from '@/constants/IndicatorBarBreakpoints';
import { toBarSegments } from '@/helpers/analytics/charts.js';
import { Box } from '@mui/material';

export const MarketingBarIndicatorField = ({ record, isViewsField = false }) => {
    const value = isViewsField ? record?.viewsPercentage : record?.conversion;
    const barColors = useBarIndicatorsColors(value, BREAKPOINTS);
    const barSegments = toBarSegments(barColors);

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <Box sx={{ display: 'flex', gap: '2px' }}>
                {barSegments.map(segment => (
                    <Box key={segment.key} sx={{ width: '4px', height: '20px', borderRadius: '2px', backgroundColor: segment.color }} />
                ))}
            </Box>
            <Box sx={{ fontSize: '14px', fontWeight: 600, lineHeight: '20px', letterSpacing: '-0.14px', whiteSpace: 'nowrap' }}>
                {isViewsField ? `${record.views} (${value}%)` : `${value}%`}
            </Box>
        </Box>
    );
};
